module.exports = __webpack_public_path__ + "static/media/inmynewworld.41d1eef5.jpg";